const images = {
  slug: 'f/images',
  uploadFmImage: () => `${images.slug}`
}

export default images
